export const PROCESS_CHANGE_PASSWORD = 'PROCESS_CHANGE_PASSWORD';
export const DONE_CHANGE_PASSWORD = 'DONE_CHANGE_PASSWORD';
export const PROCESS_FORGOT_PASSWORD = 'PROCESS_FORGOT_PASSWORD';
export const DONE_FORGOT_PASSWORD = 'DONE_FORGOT_PASSWORD';
export const PROCESS_CONFIRM_PASSWORD = 'PROCESS_CONFIRM_PASSWORD';
export const DONE_CONFIRM_PASSWORD = 'DONE_CONFIRM_PASSWORD';
export const RESET_STATUS = 'RESET_STATUS';



// WEBPACK FOOTER //
// ./src/constants/Password.tsx